<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else class="block-container">
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0">
        <span v-if="channel&&channel.name">{{channel.name}} -</span>
        <span v-if="school&&school.name">{{school.name}} -</span>
        <span>部门配置</span>
      </h3>
      <div class="pull-right">
        <el-button type="default" @click="$router.back()">返回</el-button>
      </div>
    </div>
    <div class="block">
      <el-row :gutter="20">
        <el-col :span="7">
          <div class="el-tree">
            <div class="el-tree-node" v-for="type in department_types" :key="type.name"
                 :class="[{'is-expanded':type.$$open}]">
              <div class="el-tree-node__content" @click="type.$$open=!type.$$open">
                <span class="el-tree-node__expand-icon el-icon-caret-right"
                      :class="[{'expanded': type.$$open}]"></span>
                <span class="el-tree-node__label">{{type.name}}</span>
                <div v-if="!form">
                  <icon name="plus" @click.native.stop="addDepartment(type)"></icon>
                </div>
              </div>
              <div class="el-tree-node__children" v-if="type.$$open">
                <div v-if="!type.departments.length" class="empty-block">
                  <div class="empty-text">暂无数据</div>
                </div>
                <template v-else>
                  <div class="el-tree-node" v-for="item in type.departments" :key="item.name"
                       :class="[{'is-current':department === item}]">
                    <div class="el-tree-node__content" @click="toggleDepartment(item)">
                      <span class="el-tree-node__expand-icon is-leaf"></span>
                      <span class="el-tree-node__label">{{item.name || '未命名'}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="17">
          <el-form v-if="department" ref="form" :model="form" :rules="rules">
            <div class="clearfix">
              <div class="pull-left clearfix">
                <div class="form-title" :class="{important:form}">部门名称</div>
                <div class="form-content">
                  <el-form-item v-if="form" prop="name" class="m-b-0">
                    <el-input v-model="form.name" placeholder="请输入部门名称"></el-input>
                  </el-form-item>
                  <div v-else>{{department.name}}</div>
                </div>
              </div>
              <div class="pull-right">
                <div v-if="form">
                  <el-button type="primary" @click="submit()" :loading="submit_loading>0">保存
                  </el-button>
                  <el-button type="default" @click="cancelEdit()" :disabled="submit_loading>0">
                    取消
                  </el-button>
                </div>
                <div v-else>
                  <el-button type="primary" @click="startEdit()">编辑</el-button>
                </div>
              </div>
            </div>
            <hr>
            <div class="form clearfix">
              <div class="form-title" :class="{important:form}">部门分类</div>
              <div class="form-content">
                <el-form-item v-if="form" prop="type">
                  <el-radio-group v-model="form.type">
                    <el-radio :label="type.en_name" v-for="type in department_types"
                              :key="type.name">
                      {{type.name}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-else>{{department_type_map[department.type].name}}</div>
              </div>
            </div>
            <div class="form clearfix">
              <div class="form-title">功能开通</div>
              <div class="form-content">
                <div v-for="type in func_types" :key="type.en_name">
                  <div class="clearfix">
                    <div class="pull-left func-title">{{type.name}}</div>
                    <div class="pull-right" v-if="form">
                      <el-checkbox :indeterminate="type.indeterminate" v-model="type.checked"
                                   @change="checkAll(type)" class="m-r-20"></el-checkbox>
                      <el-button type="text" @click="checkAll(type, true)">全选</el-button>
                      <el-button type="text" @click="checkAll(type, false)">全不选</el-button>
                    </div>
                  </div>
                  <el-form-item v-if="form">
                    <div v-for="(item, index) in type.funcs" :key="item.en_name">
                      <el-checkbox v-model="item.checked" @change="resetCheckAll(type)"
                                   :label="item.en_name">
                        {{item.name}}
                      </el-checkbox>
                      <br v-if="index % 3 === 2">
                    </div>
                  </el-form-item>
                  <div v-else-if="type.activeFuncs.length">
                      <span v-for="(item, index) in type.activeFuncs" :key="item.en_name">
                          <span v-if="index">、</span>{{item.name}}
                      </span>
                  </div>
                  <div v-else>（无）</div>
                </div>
              </div>
            </div>
          </el-form>
          <div class="empty-block" v-else>
            <div class="empty-text">请选择一个部门</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import cloneDeep from 'lodash/cloneDeep'
import * as Department from 'api/department'
import * as Channel from 'api/channel'
import * as School from 'api/school'
import * as Funcs from 'api/configuration/funcs'
import * as rules from 'common/rules'

export default {
  data () {
    return {
      ready: false,
      submit_loading: 0,
      funcs: [],
      func_types: [],
      departments: [],
      department_type_map: {},
      department_types: [],
      department: null,
      form: null,
      channel: null,
      school: null,
      rules: {
        name: [rules.required('部门名称为必填项')],
        type: [rules.required('部门分类为必填项')],
      },
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let query = this.$query
        let [departments, department_types, funcs, func_types, channel, school] = await Promise.all([
          Department.list(query),
          Department.types(query),
          Funcs.list(),
          Funcs.types(),
          query.channel_uid ? Channel.get(query) : null,
          query.school_uid ? School.get(query) : null,
        ])
        this.setUpDepartment(departments, department_types)
        department_types.forEach(type => type.$$open = false)
        let department_type_map = keyBy(department_types, 'en_name')
        let func_map = keyBy(funcs, 'en_name')
        let func_groups = groupBy(funcs, 'type')
        func_types.forEach(item => {
          item.funcs = func_groups[item.en_name]
          item.checked = false
          item.indeterminate = false
        })
        funcs.forEach(func => func.checked = false)
        this.departments = departments
        this.department_types = department_types
        this.department_type_map = department_type_map
        this.funcs = funcs
        this.func_map = func_map
        this.func_types = func_types
        if (departments.length) this.toggleDepartment(departments[0])
        this.channel = channel
        this.school = school
        this.ready = true
      })
    },
    setUpDepartment (departments, department_types) {
      let department_groups = groupBy(departments, 'type')
      department_types.forEach(type => {
        type.departments = department_groups[type.en_name] || []
        type.departments.forEach(department => department.$$type = type)
      })
      departments.forEach(department => {
        department.department_uid = department.uid
        department.school_uid = this.$query.school_uid
      })
    },
    async toggleDepartment (department) {
      if (this.department === department) return
      if (this.form && !await this.$confirm('你正在编辑部门，切换部门将取消当前编辑，确定要切换吗？', '提示')) return
      this.cancelEdit()
      this.department = department
      department.$$type.$$open = true
      this.resetFuncCheck()
    },
    addDepartment (type) {
      if (this.form) return
      let department = {
        school_uid: this.$query.school_uid,
        name: '',
        type: type.en_name,
        funcs: [],
        $$type: type,
      }
      type.departments.push(department)
      this.departments.push(department)
      this.toggleDepartment(department)
      this.startEdit()
    },
    startEdit () {
      if (this.form || !this.department) return
      this.form = cloneDeep(this.department)
      this.resetFuncCheck()
    },
    resetFuncCheck () {
      this.funcs.forEach(func => func.checked = false)
      this.department.funcs.forEach(func => {
        func = this.func_map[func]
        if (func) func.checked = true
      })
      this.func_types.forEach(this.resetCheckAll)
      this.func_types.forEach(type => type.activeFuncs = type.funcs.filter(func => func.checked))
    },
    cancelEdit () {
      if (!this.form) return
      if (!this.department.uid) {
        let idx = this.departments.indexOf(this.department)
        this.departments.splice(idx, 1)
        let departments = this.department.$$type.departments
        idx = departments.indexOf(this.department)
        departments.splice(this.department, 1)
        this.department = null
      }
      this.form = null
    },
    checkAll (type, checked) {
      if (checked !== undefined) type.checked = checked
      type.funcs.forEach(func => func.checked = type.checked)
      type.indeterminate = false
    },
    resetCheckAll (type) {
      let checked = false, unchecked = false
      for (let func of type.funcs) {
        func.checked ? checked = true : unchecked = true
        if (checked && unchecked) break
      }
      type.checked = !unchecked
      type.indeterminate = checked && unchecked
    },
    async submit () {
      if (this.submit_loading > 0) return
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        this.form.funcs = this.funcs.filter(func => func.checked).map(func => func.en_name)
        let department = await Department.edit(this.form)
        this.form = null
        let idx = this.departments.indexOf(this.department)
        this.departments[idx] = department
        this.setUpDepartment(this.departments, this.department_types)
        this.toggleDepartment(department)
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";
@import "src/scss/var/app";

.block-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.block {
  background-color: $color-block-background;
  padding: 20px;
  flex: 1;
  display: flex;
}

.el-row {
  width: 100%;
  height: 100%;
  display: flex;
  .el-col {
    height: 100%;
  }
}

.el-tree {
  background: #fff;
  border: 1px solid #d1dde5;
}

.el-tree, .el-form {
  height: 100%;
  overflow: auto;
}

.el-tree-node__label {
  flex: 1;
}

.el-tree-node .el-tree-node .el-tree-node__label {
  padding-left: 1em;
}

.is-current .el-tree-node__content {
  background-color: mix($color-success, white, 10%);
}

.el-tree-node__content {
  .fa-icon {
    margin-right: 10px;
    color: mix($color-normal, #fff, 75%);
    &:hover {
      color: $color-normal;
    }
  }
}

.form {
  margin: 10px 0 20px;
}

$title-width: 7em;
.form-title {
  width: $title-width;
  color: black;
  font-weight: bold;
  float: left;
  line-height: $form-line-height;
}

.func-title {
  font-weight: bold;
}

.form-content {
  line-height: $form-line-height;
  padding-left: $title-width;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/department/ConfigDepartment.vue